export const downloadInvoice = (order, userEmail) => {
  const invoiceContent = `
========================================
            TRENDOVA
        Fashion for Everyone
========================================
INVOICE
--------
Order ID:      #${order.id.slice(-8)}
Order Date:    ${new Date(order.createdAt).toLocaleString()}
Tracking ID:   ${order.trackingId}
Payment Method: ${order.paymentMethod?.toUpperCase() || 'N/A'}
Status:        ${order.status}

CUSTOMER DETAILS
----------------
Email:    ${userEmail}
Address:  ${order.address}
Phone:    ${order.phone || 'N/A'}

ORDER SUMMARY
--------------
${order.items.map(item => 
  `  ${item.name} (Size: ${item.size}, Qty: ${item.quantity})   ₹${(item.price * item.quantity).toLocaleString()}`
).join('\n')}

----------------------------------------
Subtotal:                      ₹${order.total.toLocaleString()}
Shipping:                      FREE
----------------------------------------
TOTAL:                         ₹${order.total.toLocaleString()}
----------------------------------------

Delivery Estimate: ${order.deliveryEstimate}

Thank you for shopping with TRENDOVA!
For support: support@trendova.com
========================================
  `;

  const blob = new Blob([invoiceContent], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `invoice_${order.id.slice(-8)}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};